import React from "react"
import { TabsSeeker } from "@ui-seeker/core"
import { tabSelected } from "Pages/Admin/GlobalExecution/@signals"
import { GLOBAL_EXECUTION_TABS } from "Pages/Admin/GlobalExecution/@constants"
import { Grid } from '@mui/material'


export default function AdminGlobalExecutionTabs() {


	return <Grid item xs={12}>
		<TabsSeeker
			onChange={(_, value) => tabSelected.value = value}
			value={tabSelected.value}
			tabs={
				[{
					key: GLOBAL_EXECUTION_TABS.REGULAR,
					label: 'Regular Reports',
					value: GLOBAL_EXECUTION_TABS.REGULAR,
					sx: {
						fontSize: "1.2rem"
					}
				}, {
					key: GLOBAL_EXECUTION_TABS.EXTRAS,
					label: 'Reports Extra',
					value: GLOBAL_EXECUTION_TABS.EXTRAS,
					sx: {
						fontSize: "1.2rem"
					}
				}, {
					key: GLOBAL_EXECUTION_TABS.SCRAPERS,
					label: 'Batch Scraper Searches',
					value: GLOBAL_EXECUTION_TABS.SCRAPERS,
					sx: {
						fontSize: "1.2rem"
					}
				}, {
					key:GLOBAL_EXECUTION_TABS.BATCHES,
					label: 'Batch Executions',
					value: GLOBAL_EXECUTION_TABS.BATCHES,
					sx: {
						fontSize: "1.2rem"
					}
				}]
			}
		/>
	</Grid>
}